import React from 'react';

import ScheduledCallsFragment from 'src/fragments/ScheduledCallsFragment';

const UnassignedVisitsScreen = () => <ScheduledCallsFragment />;

export default UnassignedVisitsScreen;
